import { render, staticRenderFns } from "./employerJobList.vue?vue&type=template&id=4c885394&scoped=true"
import script from "./employerJobList.vue?vue&type=script&lang=js"
export * from "./employerJobList.vue?vue&type=script&lang=js"
import style0 from "./employerJobList.vue?vue&type=style&index=0&id=4c885394&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c885394",
  null
  
)

export default component.exports